function formatDate(date) {
    let diff = new Date() - date; // the difference in milliseconds
  
    if (diff < 1000) { // less than 1 second
      return 'ahora';
    }
  
    let sec = Math.floor(diff / 1000); // convert diff to seconds
  
    if (sec < 60) {
      return 'hace '+ sec + ' segundos';
    }
  
    let min = Math.floor(diff / 60000); // convert diff to minutes
    if (min < 60) {
      return 'hace '+ min + ' minutos';
    }
  
    // format the date
    // add leading zeroes to single-digit day/month/hours/minutes
    let d = date;
    d = [
      '0' + d.getDate(),
      '0' + (d.getMonth() + 1),
      '' + d.getFullYear(),
      '0' + d.getHours(),
      '0' + d.getMinutes()
    ].map(component => component.slice(-2)); // take last 2 digits of every component
  
    // join the components into date
    return d.slice(0, 3).join('/') + ' ' + d.slice(3).join(':');
  }

  function getHour(date)
  {
    let d = date;
    d = [
      '0' + d.getHours(),
      '0' + d.getMinutes()
    ].map(component => component.slice(-2));

    return d.join(':');
  }

  function formatBytes(bytes)
  {
      if(bytes < 1024) return bytes.toString()+" Bytes";
      
      bytes = Math.floor(bytes / 1024);
      if(bytes < 1024) return bytes.toString()+" KB";

      bytes = Math.floor(bytes*10 / 1024) / 10;
      if(bytes < 1024) return bytes.toString() + "MB";

      bytes = Math.floor(bytes * 100 / 1024) / 100;
      if(bytes < 1024) return bytes.toString() + "GB";

      bytes = Math.floor(bytes * 100 / 1024) / 100;
      if(bytes < 1024) return bytes.toString() + "TB";
  }

  function getIconForType(contentType)
  {
      let splitted = contentType.split('/');

      switch(splitted[0])
      {
        case "image":
          return "FileImage";

        case "application":

          switch(splitted[1])
          {
            case "pdf":
              return "PDF";
            default:
              return "Page";
          }

        default:
          return "Page";
      }
  }

function hexToRgb(hex){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length === 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return {r: (c>>16)&255, g: (c>>8)&255, b: c&255};
    }
    throw new Error('Bad Hex');
}

function contrastFontColor(hex){
		
  /*
  From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast
  
  Color brightness is determined by the following formula: 
  ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

I know this could be more compact, but I think this is easier to read/explain.
  
  */
  
  const threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */
  
  const hRed = hexToR(hex);
  const hGreen = hexToG(hex);
  const hBlue = hexToB(hex);
  

  function hexToR(h) {return parseInt((cutHex(h)).substring(0,2),16)}
  function hexToG(h) {return parseInt((cutHex(h)).substring(2,4),16)}
  function hexToB(h) {return parseInt((cutHex(h)).substring(4,6),16)}
  function cutHex(h) {return (h.charAt(0)==="#") ? h.substring(1,7):h}

  const cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold){return "#000000";} else { return "#ffffff";}	
}

  

  export {formatDate, getHour, formatBytes, getIconForType, hexToRgb, contrastFontColor};